import { render } from "./SocialLearningResources.vue?vue&type=template&id=1b726cfe&scoped=true"
import script from "./SocialLearningResources.vue?vue&type=script&lang=js"
export * from "./SocialLearningResources.vue?vue&type=script&lang=js"

import "./SocialLearningResources.vue?vue&type=style&index=0&id=1b726cfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b726cfe"]])

export default __exports__